module.exports = __webpack_public_path__ + "img/hr-logistic-robot.f2a7fd50.png";